import { normalizePaymentRails } from "./entityCompanyTypes";

const HIGH_RISK_INCORPORATION_COUNTRIES = new Set(["AE"]);

const CROSS_BORDER_RAILS = new Set(["swift", "wire"]);

/**
 * Evaluates whether entity processing selections classify as high risk.
 * @param {object} form
 * @param {ReturnType<import('../../../../Services/baasBusinessAccountApi').getIndustryRequirements>} industryRequirements
 */
export const evaluateEntityProcessingRisk = (form, industryRequirements) => {
  const reasons = [];

  if (industryRequirements?.autoSetHighRisk) {
    reasons.push("industry_high_risk");
  }

  if (form.industry === "cryptocurrency") {
    reasons.push("cryptocurrency");
  }

  const purposes = Array.isArray(form.purposeOfAccount) ? form.purposeOfAccount : [];
  if (purposes.includes("card_issuing")) {
    reasons.push("card_issuing");
  }

  const rails = normalizePaymentRails(form.expectedPaymentRails);
  if (rails.some((rail) => CROSS_BORDER_RAILS.has(rail))) {
    reasons.push("cross_border_rails");
  }

  if (form.makesInternationalPayments) {
    reasons.push("international_payments");
  }

  if (HIGH_RISK_INCORPORATION_COUNTRIES.has(form.countryOfIncorporation)) {
    reasons.push("high_risk_country");
  }

  const operationCountries = form.countriesOfOperation ?? [];
  if (operationCountries.length > 3) {
    reasons.push("multi_jurisdiction");
  }

  const uniqueReasons = [...new Set(reasons)];

  return {
    isHighRisk: uniqueReasons.length > 0,
    reasons: uniqueReasons,
  };
};
